<template>
  <!-- :is 可根據傳入參數的不同，而去切換不同的元件 -->

  <component :is="resolveLayout">
    <router-view></router-view>
    <v-overlay v-show="showLoadingPage" z-index="999">
      <v-progress-circular color="primary" indeterminate size="64" />
    </v-overlay>
    <Snack :type="snackType" :text="snackText" :show="showSnack" :timeout="snackTimeout" :allowClose="snackClose" />
    <Alert />
    <ConfirmLeaveDialog />
    <MediaPopup />
    <v-overlay :value="showOverlay" :z-index="8"></v-overlay>
    <ConfirmDialog ref="globalConfirmDialog" />
  </component>
</template>

<script>
import { computed } from '@vue/composition-api'
import { useRouter } from '@/utils'
import LayoutBlank from '@/views/layouts/Blank.vue'
import LayoutContent from '@/views/layouts/Content.vue'
import Snack from '@/components/layout/Snack'
import Alert from '@/components/layout/Alert.vue'
import ConfirmLeaveDialog from '@/components/layout/ConfirmLeaveDialog.vue'
import MediaPopup from './components/layout/MediaPopup.vue'
import ConfirmDialog from './components/ConfirmDialog.vue'

export default {
  components: {
    LayoutBlank,
    LayoutContent,
    Snack,
    Alert,
    ConfirmLeaveDialog,
    MediaPopup,
    ConfirmDialog,
  },
  provide() {
    // Make the ref available to descendants
    return {
      getConfirmDialogRef: () => this.$refs.globalConfirmDialog,
    }
  },
  setup() {
    const { route } = useRouter()

    const resolveLayout = computed(() => {
      // https://vuejs.org/v2/guide/computed.html#Computed-Properties
      // Handles initial route
      if (route.value.name === null) return null

      if (route.value.meta.layout === 'blank') return 'layout-blank'

      return 'layout-content'
    })

    return {
      resolveLayout,
    }
  },
  computed: {
    showLoadingPage() {
      return this.$store.getters.showLoadingPage
    },
    snackType() {
      return this.$store.getters.snackMessage.type
    },
    snackText() {
      return this.$store.getters.snackMessage.message
    },
    showSnack() {
      return this.$store.getters.snackMessage.show
    },
    snackTimeout() {
      return this.$store.getters.snackMessage.timeout
    },
    snackClose() {
      return this.$store.getters.snackMessage.allowClose
    },
    showOverlay() {
      return this.$store.getters.showOverlay
    },
  },
}
</script>
